import React from 'react';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {InteractiveTable, Tag, AvatarList} from 'components';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {PerformanceReviewReviewee} from 'stores/performance_reviews';

const CycleName = observer(({model}) => {
  return (
    <div className='flex align-items-middle'>
      {model.cycle.name}
      {!model.sharedAt && !model.scheduled && <Tag colour='dodger' className='ml1'>
        <FormattedMessage id='employees.profile.performance.reviews.Not Shared'/>
      </Tag>}
      {model.scheduled && <Tag colour='waterloo' className='ml1'>
        <FormattedMessage id='employees.profile.performance.reviews.Scheduled'/>
      </Tag>}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.performance.reviews.Cycle',
    width: 5,
    component: CycleName
  },
  {
    header: 'employees.profile.performance.reviews.Reviewers',
    width: 3,
    render: model => <AvatarList limit={3} moreModalEnabled employees={model.reviewers}/>
  },
  {
    header: 'employees.profile.performance.reviews.Due Date',
    width: 4,
    attribute: 'cycle.dueDateView'
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.performance.reviews.No reviews to display'
};

const ReviewsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.performance.reviews.Performance Reviews')}
      columns={COLUMNS}
      showLinks={false}
      showPath={model => `/reviews${model.writeReviewsPath}`}
      proxy={{
        type: 'async',
        endpoint: endpoints.PERFORMANCE_REVIEWS.REVIEWEES.FOR_EMPLOYEE.with(employee.id),
        modelType: types.PERFORMANCE_REVIEWS.REVIEWEE,
        model: PerformanceReviewReviewee,
        pageSize: 5
      }}
      localization={LOCALIZATION}
    />
  );
});

export default ReviewsTable;
